import { jsx as _jsx } from "react/jsx-runtime";
import { useScreenSize, ScreenSize } from '@common/responsive/use-screen-size';
import { Navbar } from './navbar';
import { MobileNavbar } from './mobile-navbar';
export function NavigationMenu() {
    const screen = useScreenSize();
    return screen === ScreenSize.MOBILE ? _jsx(MobileNavbar, {}) : _jsx(Navbar, {});
}
